module.exports = __webpack_public_path__ + "static/media/ostatnie.3811aa8a.jpg";